<div
  *ngIf="platform !== PlatformEnum.mobile"
  class="container"
  [class.warning-msg]="
    product?.drawerMsg?.isWarning || product?.productCardWarningMsg?.primaryText
  "
  [class.message]="
    !!product?.drawerMsg?.message && !product.drawerMsg?.isWarning
  "
>
  <app-product-card-drawer
    [drawerMessage]="!product?.hasAlternative ? product?.drawerMsg : undefined"
    [warningMessage]="product?.productCardWarningMsg"
    (infoIconClickEmitter)="handleProductImageClick()"
  >
  </app-product-card-drawer>

  <div class="card">
    <div class="card-upper">
      <div class="image-col">
        <div class="image-container" (click)="handleProductImageClick()">
          <img
            *ngIf="!!product?.smallImageUrl"
            src="{{ product?.smallImageUrl }}"
          />
          <ion-icon
            *ngIf="!product?.smallImageUrl"
            data-cy="product-card-no-image-icon"
            class="no-image"
            name="restaurant"
          ></ion-icon>
        </div>
      </div>
      <div class="product-info-col">
        <div class="brand">{{ product?.summary?.brand | lowercase }}</div>
        <a class="product-title" (click)="handleProductImageClick()">
          {{ product?.summary?.productDescTxtl | lowercase }}
        </a>
        <div class="product-number-size">
          <p>#{{ product?.summary?.productNumber }}</p>
          <img src="assets/images/separator.png" />
          <p>{{ product?.summary?.salesPackSize }}</p>
          <img
            *ngIf="!!product?.pricePerPortion"
            src="assets/images/separator.png"
          />
          <p *ngIf="!!product?.pricePerPortion">
            {{ product?.pricePerPortion }}
          </p>
          <img
            *ngIf="!!product?.detail?.servingsPerCase"
            src="assets/images/separator.png"
          />
          <p *ngIf="!!product?.detail?.servingsPerCase">
            {{ product?.detail?.servingsPerCase }}
            {{ 'i18n.betterBuys.servingsPerCase' | translate }}
          </p>
          <ion-icon
            *ngIf="!product?.samePackSize"
            name="alert-circle"
          ></ion-icon>
        </div>

        <div class="benefits-container">
          <div
            class="benefits-line"
            *ngFor="let benefit of product?.formattedBenefits"
          >
            <ion-icon name="checkmark-outline"></ion-icon>
            <div class="benefits">{{ benefit }}</div>
          </div>
        </div>

        <div *ngIf="!product?.samePackSize" class="size-warning">
          <ion-icon name="alert-circle"></ion-icon>
          <div>{{ 'i18n.betterBuys.packSizeWarning' | translate }}</div>
        </div>
        <div class="tags">
          <app-usf-product-tag-list
            [tagList]="product?.productTags"
            [maxTags]="3"
            [product]="product"
            [allTagsClickable]="true"
          ></app-usf-product-tag-list>
        </div>
      </div>
      <div class="pricing-ordering-col">
        <div
          *ngIf="
            platform === PlatformEnum.desktop ||
            platform === PlatformEnum.tablet
          "
          class="savings-row"
        >
          <app-better-buy-savings
            [savings]="product?.savings"
            [savingsUom]="product?.savingsUom"
            [annualSavings]="product?.annualSavings"
            [annualSavingsUom]="product?.annualSavingsUom"
            [savingsPerCase]="product?.savingsPerCase"
            [pricingAvailable]="product?.pricingAvailableForSavings"
            [flexDirection]="'column'"
          ></app-better-buy-savings>
        </div>
        <div
          class="pricing-ordering-row"
          [class.is-tablet]="platform === PlatformEnum.tablet"
        >
          <div class="quantity-line">
            <app-quantity-input
              *ngIf="!product?.hideQuantityBoxes"
              [productNumber]="product?.summary?.productNumber"
              [quantity]="product?.casesOrdered"
              [isDisabled]="
                !isOnline ||
                product?.inventory?.isSpecialOrder ||
                !product?.orderable ||
                product?.notFound
              "
              [isOffline]="!isOnline"
              [isEaches]="false"
              [platform]="platform"
              [isProductCard]="true"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
            >
            </app-quantity-input>
            <app-price-display
              [disabled]="pricingDisabled"
              [price]="product?.pricing"
              [displayCases]="true"
              [catchWeightFlag]="product?.summary?.catchWeightFlag"
              [priceUom]="product?.summary?.priceUom"
            ></app-price-display>
          </div>
          <div *ngIf="product?.summary?.breakable" class="quantity-line">
            <app-quantity-input
              *ngIf="!product?.hideQuantityBoxes"
              [productNumber]="product?.summary?.productNumber"
              [quantity]="product?.eachesOrdered"
              [isDisabled]="
                !isOnline ||
                product?.inventory?.isSpecialOrder ||
                !product?.orderable ||
                product?.notFound
              "
              [isOffline]="!isOnline"
              [isEaches]="true"
              [platform]="platform"
              [isProductCard]="true"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
            >
            </app-quantity-input>
            <app-price-display
              [disabled]="pricingDisabled"
              [price]="product?.pricing"
              [displayCases]="false"
              [catchWeightFlag]="product?.summary?.catchWeightFlag"
              [priceUom]="product?.summary?.priceUom"
            ></app-price-display>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showAcceptSwapButton" class="card-lower">
      <ion-button (click)="acceptSwap()" class="usf-fill-green-button">
        {{ 'i18n.betterBuys.acceptSwap' | translate }}
      </ion-button>
    </div>
  </div>
</div>

<div
  *ngIf="platform === PlatformEnum.mobile"
  class="mobile-container"
  [class.warning-msg]="
    product?.drawerMsg?.isWarning || product?.productCardWarningMsg?.primaryText
  "
>
  <app-product-card-drawer
    [drawerMessage]="!product?.hasAlternative ? product?.drawerMsg : undefined"
    [warningMessage]="product?.productCardWarningMsg"
    (infoIconClickEmitter)="handleProductImageClick()"
  >
  </app-product-card-drawer>

  <div class="card">
    <div class="mobile-image-row">
      <div class="image-col">
        <div class="image-container" (click)="handleProductImageClick()">
          <img
            *ngIf="!!product?.smallImageUrl"
            src="{{ product?.smallImageUrl }}"
          />
          <ion-icon
            *ngIf="!product?.smallImageUrl"
            data-cy="product-card-no-image-icon"
            class="no-image"
            name="restaurant"
          ></ion-icon>
        </div>
      </div>
      <div class="product-info-col">
        <div class="brand">{{ product?.summary?.brand | lowercase }}</div>
        <a class="product-title" (click)="handleProductImageClick()">
          {{ product?.summary?.productDescTxtl | lowercase }}
        </a>
        <div class="product-number-size">
          <p>#{{ product?.summary?.productNumber }}</p>
          <img src="assets/images/separator.png" />
          <p>{{ product?.summary?.salesPackSize }}</p>
          <ion-icon
            *ngIf="!product?.samePackSize"
            name="alert-circle"
          ></ion-icon>
        </div>
        <div
          *ngIf="
            !!product?.pricePerPortion || !!product?.detail?.servingsPerCase
          "
          class="price-per-portion-servings-per-case"
        >
          <p *ngIf="!!product?.pricePerPortion">
            {{ product?.pricePerPortion }}
          </p>
          <img
            *ngIf="
              !!product?.detail?.servingsPerCase && !!product?.pricePerPortion
            "
            src="assets/images/separator.png"
          />
          <p *ngIf="!!product?.detail?.servingsPerCase">
            {{ product?.detail?.servingsPerCase }}
            {{ 'i18n.betterBuys.servingsPerCase' | translate }}
          </p>
        </div>
      </div>
    </div>

    <div class="savings-row">
      <app-better-buy-savings
        *ngIf="platform === PlatformEnum.mobile"
        [savings]="product?.savings"
        [savingsUom]="product?.savingsUom"
        [annualSavings]="product?.annualSavings"
        [annualSavingsUom]="product?.annualSavingsUom"
        [savingsPerCase]="product?.savingsPerCase"
        [pricingAvailable]="product?.pricingAvailableForSavings"
        [flexDirection]="'column'"
      ></app-better-buy-savings>
    </div>

    <div class="benefits-container">
      <div
        class="benefits-line"
        *ngFor="let benefit of product?.formattedBenefits"
      >
        <ion-icon name="checkmark-outline"></ion-icon>
        <div class="benefits">{{ benefit }}</div>
      </div>
    </div>

    <div *ngIf="!product?.samePackSize" class="size-warning">
      <ion-icon name="alert-circle"></ion-icon>
      <div>{{ 'i18n.betterBuys.packSizeWarning' | translate }}</div>
    </div>

    <div class="pricing-ordering-row">
      <div class="quantity-line case-qty-line">
        <app-quantity-input
          *ngIf="!product?.hideQuantityBoxes"
          [productNumber]="product?.summary?.productNumber"
          [quantity]="product?.casesOrdered"
          [isDisabled]="
            !isOnline ||
            product?.inventory?.isSpecialOrder ||
            !product?.orderable ||
            product?.notFound
          "
          [isOffline]="!isOnline"
          [isEaches]="false"
          [platform]="platform"
          [isProductCard]="true"
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
        >
        </app-quantity-input>
        <app-price-display
          [disabled]="pricingDisabled"
          [price]="product?.pricing"
          [displayCases]="true"
          [catchWeightFlag]="product?.summary?.catchWeightFlag"
          [priceUom]="product?.summary?.priceUom"
        ></app-price-display>
      </div>
      <div *ngIf="product?.summary?.breakable" class="quantity-line">
        <app-quantity-input
          *ngIf="!product?.hideQuantityBoxes"
          [productNumber]="product?.summary?.productNumber"
          [quantity]="product?.eachesOrdered"
          [isDisabled]="
            !isOnline ||
            product?.inventory?.isSpecialOrder ||
            !product?.orderable ||
            product?.notFound
          "
          [isOffline]="!isOnline"
          [isEaches]="true"
          [platform]="platform"
          [isProductCard]="true"
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
        >
        </app-quantity-input>
        <app-price-display
          [disabled]="pricingDisabled"
          [price]="product?.pricing"
          [displayCases]="false"
          [catchWeightFlag]="product?.summary?.catchWeightFlag"
          [priceUom]="product?.summary?.priceUom"
        ></app-price-display>
      </div>
    </div>

    <app-usf-product-tag-list
      *ngIf="product?.productTags?.length > 0"
      [tagList]="product?.productTags"
      [maxTags]="3"
      [product]="product"
      [allTagsClickable]="true"
    ></app-usf-product-tag-list>

    <div class="card-lower" *ngIf="showAcceptSwapButton">
      <ion-button (click)="acceptSwap()" class="usf-fill-green-button">
        {{ 'i18n.betterBuys.acceptSwap' | translate }}
      </ion-button>
    </div>
  </div>
</div>
